import gql from "graphql-tag";

// Staff props
const AppointmentStaffProps = gql`
    fragment AppointmentStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        email
        type {
            id
            name
        }
        designation {
            id
            name
        }
        department {
            id
            name
        }
        image
    }
`;

const AppointmentProps = gql`
    fragment AppointmentProps on Appointment {
        id
        date
        assignee {
            ...AppointmentStaffProps
        }
        bookedBy {
            ...AppointmentStaffProps
        }
        note
        department {
            id
            name
        }
        attended
        reassigned {
            status
            author {
                ...AppointmentStaffProps
            }
        }
        patient {
            id
            name
            profile_picture
            hcn
            dob
            email
            gender
        }
    }
    ${AppointmentStaffProps}
`;

const LIST = gql`
    query GetAppointments($page: Int, $limit: Int) {
        GetAppointments(page: $page, limit: $limit) {
            docs {
                ...AppointmentProps
            }
            totalDocs
            totalPages
            page
            limit
            prevPage
            nextPage
        }
    }
    ${AppointmentProps}
`;

const LIST_STAFF = gql`
    query GetStaffMany($site: ID!) {
        GetStaffList(page: 1, limit: 2000) {
            docs {
                ...AppointmentStaffProps
            }
        }
        GetDepartments(site: $site) {
            docs {
                id
                name
            }
        }
    }
    ${AppointmentStaffProps}
`;

const CREATE = gql`
    mutation NewAppointment($model: AppointmentInput!) {
        BookAppointment(model: $model) {
            message
            doc {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;
const REASSIGN = gql`
    mutation AppointmentReassignment($id: ID!, $newStaff: ID!) {
        ReassginAppointment(newStaff: $newStaff, id: $id) {
            message
            doc {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;

const UPDATE = gql`
    mutation UpdateAppointment($id: ID!, $note: String!, $department: ID!) {
        UpdateAppointment(id: $id, note: $note, department: $department) {
            message
            doc {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;

const DASHBOARD = gql`
    query DashboardData {
        TotalAppointments
        ActiveAppointmentCount
        AppointmentAttendanceRatio {
            attended
            count
        }
    }
`;

const GET_APPOINTMENTS = gql`
    query GetAssignedAppointments($page: Int, $limit: Int) {
        GetStaffAppointments(page: $page, limit: $limit) {
            limit
            page
            prevPage
            nextPage
            totalDocs
            totalPages
            docs {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;

const ATTEND = gql`
    mutation AttendAppointment($id: ID!) {
        AttendAppointment(id: $id) {
            message
            doc {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;

export const GET_ACTIVE_APPOINTMENT = gql`
    query GetActiveAppoints {
        GetActiveAppointments {
            docs {
                ...AppointmentProps
            }
        }
    }
    ${AppointmentProps}
`;

export { LIST, LIST_STAFF, CREATE, REASSIGN, UPDATE, DASHBOARD, GET_APPOINTMENTS, ATTEND };
